import { post } from '../request'

//添加区域
export const cityCarGather = params => {
    return post('/statistics/cityCarGather', params)
}